const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  resources: state => state.user.resources,
  addRouters: state => state.permission.addRouters,
  routesLoaded: state => state.permission.routesLoaded,
  hasDashboard: state => state.permission.hasDashboard,
  landingPath: state => state.permission.landingPath,
  routers: state => state.permission.routers,
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js